<template>
    <div class="uk-padding">
        <h2 class="uk-heading-line uk-text-center uk-text-bold"><span style="color: #033860 ;">Helping with the fight against Covid-19</span></h2>
        <div class="uk-container uk-container-xsmall">
            <div class="uk-child-width-1-1@m" uk-grid>
                <div>

                    <!--<video src="/Ncu_promo_website.mp4" controls   uk-video style="border-radius: 10px"></video>-->
                </div>
                <div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "covid"
    }
</script>

<style scoped>

</style>